"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  PaginateFilter3: ['paginate-filter-3', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M3.750 0.746 L23.250 0.746 L23.250 20.246 L3.750 20.246 Z', 'M20.25,23.246h-18a1.5,1.5,0,0,1-1.5-1.5v-18', 'M11.25,8.246a1.5,1.5,0,0,1,1.5-1.5l1.135,0a1.873,1.873,0,0,1-.008,3.745,1.873,1.873,0,0,1,.008,3.746l-1.135,0a1.5,1.5,0,0,1-1.5-1.5']],
  PaginateFilter5: ['paginate-filter-5', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M3.750 0.746 L23.250 0.746 L23.250 20.246 L3.750 20.246 Z', 'M20.25,23.246h-18a1.5,1.5,0,0,1-1.5-1.5v-18', 'M11.25,14.246h2.625a1.875,1.875,0,0,0,1.875-1.875c0-3.333-4.5-.417-4.5-3.75V6.746h4.5']],
  PaginateFilter10: ['paginate-filter-10', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M3.750 0.746 L23.250 0.746 L23.250 20.246 L3.750 20.246 Z', 'M20.25,23.246h-18a1.5,1.5,0,0,1-1.5-1.5v-18', 'M11.25,14.246V7.5a.751.751,0,0,0-1.2-.6l-1.8,1.35', 'M9.75 14.246L12.75 14.246', 'M18.75,12a2.25,2.25,0,1,1-4.5,0V9a2.25,2.25,0,0,1,4.5,0Z']],
  PaginateFilterCamera: ['paginate-filter-camera', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M19.5,7.5l-3,1v-1A1.5,1.5,0,0,0,15,6H9A1.5,1.5,0,0,0,7.5,7.5v6A1.5,1.5,0,0,0,9,15h6a1.5,1.5,0,0,0,1.5-1.5v-1l3,1Z', 'M3.750 0.746 L23.250 0.746 L23.250 20.246 L3.750 20.246 Z', 'M20.25,23.246h-18a1.5,1.5,0,0,1-1.5-1.5v-18']],
  PaginateFilter8: ['paginate-filter-8', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M3.750 0.746 L23.250 0.746 L23.250 20.246 L3.750 20.246 Z', 'M20.25,23.246h-18a1.5,1.5,0,0,1-1.5-1.5v-18', 'M11.250 12.371 A2.250 2.250 0 1 0 15.750 12.371 A2.250 2.250 0 1 0 11.250 12.371 Z', 'M11.812 8.434 A1.688 1.688 0 1 0 15.188 8.434 A1.688 1.688 0 1 0 11.812 8.434 Z']],
  PaginateFilter9: ['paginate-filter-9', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M3.750 0.746 L23.250 0.746 L23.250 20.246 L3.750 20.246 Z', 'M20.25,23.246h-18a1.5,1.5,0,0,1-1.5-1.5v-18', 'M11.250 8.996 A2.250 2.250 0 1 0 15.750 8.996 A2.250 2.250 0 1 0 11.250 8.996 Z', 'M12.75,14.246a3,3,0,0,0,3-3V9']],
  PaginateFilterAudio: ['paginate-filter-audio', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M3.750 0.746 L23.250 0.746 L23.250 20.246 L3.750 20.246 Z', 'M20.25,23.246h-18a1.5,1.5,0,0,1-1.5-1.5v-18', 'M9.750 14.621 A1.875 1.875 0 1 0 13.500 14.621 A1.875 1.875 0 1 0 9.750 14.621 Z', 'M13.5,14.621V4.5l2.878,2.879a4.651,4.651,0,0,1,.872,5.371']],
  PaginateFilterMusic: ['paginate-filter-music', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M3.750 0.746 L23.250 0.746 L23.250 20.246 L3.750 20.246 Z', 'M20.25,23.246h-18a1.5,1.5,0,0,1-1.5-1.5v-18', 'M7.500 14.621 A1.875 1.875 0 1 0 11.250 14.621 A1.875 1.875 0 1 0 7.500 14.621 Z', 'M15.000 12.371 A1.875 1.875 0 1 0 18.750 12.371 A1.875 1.875 0 1 0 15.000 12.371 Z', 'M11.25,14.621V7.828a1.5,1.5,0,0,1,1.026-1.423l4.5-1.251A1.5,1.5,0,0,1,18.75,6.577v5.794']],
  PaginateFilterPlus1: ['paginate-filter-plus-1', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M3.750 0.746 L23.250 0.746 L23.250 20.246 L3.750 20.246 Z', 'M20.25,23.246h-18a1.5,1.5,0,0,1-1.5-1.5v-18', 'M17.25,14.246V7.5a.751.751,0,0,0-1.2-.6l-1.8,1.35', 'M15.75 14.246L18.75 14.246', 'M6.75 11.246L12.75 11.246', 'M9.75 8.246L9.75 14.246']],
  PaginateFilterVideo: ['paginate-filter-video', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M3.750 0.746 L23.250 0.746 L23.250 20.246 L3.750 20.246 Z', 'M20.25,23.246h-18a1.5,1.5,0,0,1-1.5-1.5v-18', 'M9.75,6.748v7.5a.75.75,0,0,0,1.136.643l6-3.749a.75.75,0,0,0,0-1.286l-6-3.749A.751.751,0,0,0,9.75,6.748Z']],
  PaginateFilter2: ['paginate-filter-2', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M3.750 0.746 L23.250 0.746 L23.250 20.246 L3.750 20.246 Z', 'M20.25,23.246h-18a1.5,1.5,0,0,1-1.5-1.5v-18', 'M11.5,8.236a2.181,2.181,0,0,1,2.068-1.49h0a2.18,2.18,0,0,1,2.179,2.18h0a1.985,1.985,0,0,1-.58,1.4l-3.92,3.919h4.5']],
  PaginateFilterPicture: ['paginate-filter-picture', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M3.750 0.746 L23.250 0.746 L23.250 20.246 L3.750 20.246 Z', 'M20.25,23.246h-18a1.5,1.5,0,0,1-1.5-1.5v-18', 'M8.624 6.746L8.624 6.746', 'M8.624,6.746A.375.375,0,1,0,9,7.121a.375.375,0,0,0-.375-.375', 'M20.25,15.746,16.38,9.91A.749.749,0,0,0,15.142,9.9l-1.995,2.85-1.237-.989a.75.75,0,0,0-1.092.17L8.272,15.746Z']],
  PaginateFilterMail: ['paginate-filter-mail', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M3.750 0.746 L23.250 0.746 L23.250 20.246 L3.750 20.246 Z', 'M20.25,23.246h-18a1.5,1.5,0,0,1-1.5-1.5v-18', 'M18.75,8.246v6a1.5,1.5,0,0,1-1.5,1.5H9.75a1.5,1.5,0,0,1-1.5-1.5v-6', 'M18.75,8.246a1.5,1.5,0,0,0-1.5-1.5H9.75a1.5,1.5,0,0,0-1.5,1.5l4.455,2.773a1.5,1.5,0,0,0,1.59,0Z']],
  PaginateFilterPlus: ['paginate-filter-plus', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M3.750 0.746 L23.250 0.746 L23.250 20.246 L3.750 20.246 Z', 'M20.25,23.246h-18a1.5,1.5,0,0,1-1.5-1.5v-18', 'M14.25 5.246L14.25 14.246', 'M9.75 9.746L18.75 9.746']],
  PaginateFilter4: ['paginate-filter-4', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M3.750 0.746 L23.250 0.746 L23.250 20.246 L3.750 20.246 Z', 'M20.25,23.246h-18a1.5,1.5,0,0,1-1.5-1.5v-18', 'M15.75 14.246L15.75 12.746', 'M15.75,12.746V6.761a8.26,8.26,0,0,0-4.481,5.985H15.75']],
  PaginateFilter6: ['paginate-filter-6', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M3.750 0.746 L23.250 0.746 L23.250 20.246 L3.750 20.246 Z', 'M20.25,23.246h-18a1.5,1.5,0,0,1-1.5-1.5v-18', 'M11.250 11.996 A2.250 2.250 0 1 0 15.750 11.996 A2.250 2.250 0 1 0 11.250 11.996 Z', 'M14.25,6.746a3,3,0,0,0-3,3V12']],
  PaginateFilterAndroid: ['paginate-filter-android', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M3.750 0.746 L23.250 0.746 L23.250 20.246 L3.750 20.246 Z', 'M20.25,23.246h-18a1.5,1.5,0,0,1-1.5-1.5v-18', 'M18.75,15.746a1.5,1.5,0,0,1-1.5,1.5H9.75a1.5,1.5,0,0,1-1.5-1.5v-4.5h10.5Z', 'M18.75,11.246a5.25,5.25,0,0,0-10.5,0Z', 'M10.663 6.828L9.75 4.439', 'M16.336 6.828L17.25 4.439']],
  PaginateFilter7: ['paginate-filter-7', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M3.750 0.746 L23.250 0.746 L23.250 20.246 L3.750 20.246 Z', 'M20.25,23.246h-18a1.5,1.5,0,0,1-1.5-1.5v-18', 'M11.713,6.746H15a.751.751,0,0,1,.671,1.086l-3.208,6.414']],
  PaginateFilter1: ['paginate-filter-1', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M3.750 0.746 L23.250 0.746 L23.250 20.246 L3.750 20.246 Z', 'M20.25,23.246h-18a1.5,1.5,0,0,1-1.5-1.5v-18', 'M14.25,14.246V7.5a.751.751,0,0,0-1.2-.6l-1.8,1.35', 'M12.75 14.246L15.75 14.246']],
  PaginateFilterText: ['paginate-filter-text', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M3.750 0.746 L23.250 0.746 L23.250 20.246 L3.750 20.246 Z', 'M20.25,23.246h-18a1.5,1.5,0,0,1-1.5-1.5v-18', 'M8.25 6.746L18.75 6.746', 'M8.25 9.746L18.75 9.746', 'M8.25 12.746L15.75 12.746']],
  PaginateFilterHeart: ['paginate-filter-heart', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M3.750 0.746 L23.250 0.746 L23.250 20.246 L3.750 20.246 Z', 'M20.25,23.246h-18a1.5,1.5,0,0,1-1.5-1.5v-18', 'M13.5,15.746,8.386,10.412a3.027,3.027,0,0,1-.567-3.493h0a3.026,3.026,0,0,1,4.846-.786l.835.835.835-.835a3.026,3.026,0,0,1,4.846.786h0a3.027,3.027,0,0,1-.567,3.493Z']]
};
exports["default"] = _default;